<template>
  <s-section
    class="resources"
    is-sub-section
  >
    <template v-for="resource in resources">
      <s-section
        :key="resource.id"
        is-sub-section
        :title="resource.title"
      >
        <div class="resources__items">
          <resources-item
            v-for="item in resource.items"
            :key="item.id"
            :item="item"
          ></resources-item>
        </div>
      </s-section>
    </template>
  </s-section>
</template>

<script>
import ResourcesItem from './ResourcesItem'

export default {
  name: 'Resources',
  components: {
    ResourcesItem
  },
  props: {
    resources: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
.resources__items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 32px;

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px 40px;
  }

  @media (max-width: $breakpoint-md) {
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
    grid-gap: 16px 40px;
  }
}
</style>